/* ARRAY - shade swatches on EVERY product card. 29 Sep 2026.
   Loaded on every page from snippets/beyondads-rewards-launcher.liquid.

   The collection grid (.bc-card) and the Rhode / Skin Glow rows (.ar-cell) print
   their swatches in Liquid. Every other card is listed in TYPES below; for those
   this script reads the product handle from the card's link, fetches
   /products/<handle>?view=swatches (templates/product.swatches.liquid - JSON,
   cached per tab in sessionStorage under bsw2:) and draws the row under the price.

   Any product with 2+ variants and a shade-like option gets dots (Shopify swatch
   colour/image, or the shade's own photo when no swatch is set); everything else
   keeps an empty 14px row so the + buttons stay level.

   Hover a dot: the card photo previews that shade. Click: the shade sticks (ring
   on the dot), and every link on the card goes to that variant. Leaving the card
   returns to the picked shade, or the original photo if none was picked.
   Clicks are taken in the CAPTURE phase and stopped there: several cards are <a>
   elements or have their own click handlers (carousels, quick add), and a dot
   must never open the product page. */
(function () {
  'use strict';
  if (window.__baSw) return;
  window.__baSw = true;

  var MAX = 6;
  var TYPES = [
    { unit: '.dh-cell', img: '.dh-shot img', after: '.dh-price' },
    { unit: '.su-card', img: '.su-shot img', after: '.su-price' },
    { unit: '.kb2-item', img: '.kb2-shot', after: '.kb2-price' },
    { unit: '.pdp-up', img: '.pdp-up-img img', after: '.pdp-up-p' },
    { unit: '.gt-mface', after: '.gt-line', img: function (u) {
        /* best sellers: each slot cycles through several products; the Nth
           name/price block belongs to the Nth photo in the same card */
        var card = u.closest('.gt-card');
        if (!card) return null;
        var i = Array.prototype.indexOf.call(card.querySelectorAll('.gt-mface'), u);
        var face = card.querySelectorAll('.gt-face')[i];
        return face ? face.querySelector('img') : null;
      } }
  ];
  var SEL = TYPES.map(function (t) { return t.unit; }).join(',');

  var st = document.createElement('style');
  st.textContent =
    '.bsw{display:flex;justify-content:center;align-items:center;gap:6px;height:14px;margin:8px 0 0;padding:0}' +
    '.bsw-dot{flex:none;width:13px;height:13px;margin:0;padding:0;border:0;border-radius:50%;cursor:pointer;' +
      'background:#E8E2DC center/cover no-repeat;box-shadow:inset 0 0 0 1px rgba(0,0,0,.12);transition:transform .15s ease}' +
    '.bsw-dot:hover,.bsw-dot:focus-visible{transform:scale(1.2)}' +
    '.bsw-dot:focus-visible{outline:1px solid #2B2420;outline-offset:2px}' +
    '.bsw-dot.is-on{box-shadow:inset 0 0 0 1px rgba(0,0,0,.12),0 0 0 2px #fff,0 0 0 3px #2B2420}' +
    '.bsw-dot.is-out{opacity:.4}' +
    '.bsw-more{font-size:11px;letter-spacing:.04em;line-height:14px;color:#6E6259;text-decoration:none}' +
    '@media (prefers-reduced-motion:reduce){.bsw-dot{transition:none}}';
  document.head.appendChild(st);

  function typeOf(u) {
    for (var i = 0; i < TYPES.length; i++) if (u.matches(TYPES[i].unit)) return TYPES[i];
    return null;
  }
  function imgOf(u) {
    var t = typeOf(u);
    if (!t) return null;
    return typeof t.img === 'function' ? t.img(u) : u.querySelector(t.img);
  }
  function linksOf(u) {
    var out = [];
    if (u.matches('a[href*="/products/"]')) out.push(u);
    Array.prototype.forEach.call(u.querySelectorAll('a[href*="/products/"]'), function (a) {
      if (!a.classList.contains('bsw-more')) out.push(a);
    });
    var im = imgOf(u), a = im && im.closest('a[href*="/products/"]');
    if (a && out.indexOf(a) < 0) out.push(a);
    return out;
  }
  function handleOf(u) {
    var l = linksOf(u)[0];
    var m = l && (l.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }
  function setImg(u, src) {
    var im = imgOf(u);
    if (!im || !src || im.getAttribute('src') === src) return;
    im.setAttribute('src', src);
    im.removeAttribute('srcset');
    im.removeAttribute('sizes');
  }

  var cache = {};
  function load(h) {
    if (cache[h]) return cache[h];
    var key = 'bsw2:' + h;
    try {
      var hit = sessionStorage.getItem(key);
      if (hit) { cache[h] = Promise.resolve(JSON.parse(hit)); return cache[h]; }
    } catch (e) {}
    cache[h] = fetch('/products/' + encodeURIComponent(h) + '?view=swatches', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : '{"v":[]}'; })
      .then(function (t) {
        var d; try { d = JSON.parse(t); } catch (e) { d = { v: [] }; }
        try { sessionStorage.setItem(key, JSON.stringify(d)); } catch (e) {}
        return d;
      })
      .catch(function () { return { v: [] }; });
    return cache[h];
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function fill(u, row) {
    if (u.__bswDone) return;
    u.__bswDone = true;
    var h = handleOf(u);
    if (!h) return;
    load(h).then(function (d) {
      var v = (d && d.v) || [];
      if (v.length < 2) return;
      var html = '';
      v.slice(0, MAX).forEach(function (s) {
        var bg = s.i ? 'background-image:url(' + s.i + ')' : (s.c ? 'background-color:' + s.c : '');
        html += '<button type="button" class="bsw-dot' + (s.a === false ? ' is-out' : '') + '" style="' + esc(bg) +
          '" data-p="' + esc(s.p) + '" data-u="' + esc(s.u) + '" title="' + esc(s.n) + '" aria-label="' + esc(s.n) + '"></button>';
      });
      if (v.length > MAX) html += '<span class="bsw-more">+' + (v.length - MAX) + '</span>';
      row.innerHTML = html;
      row.setAttribute('aria-label', v.length + ' shades');
      row.removeAttribute('aria-hidden');
    });
  }

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (ents) {
    ents.forEach(function (en) {
      if (!en.isIntersecting) return;
      io.unobserve(en.target);
      fill(en.target, en.target.__bsw);
    });
  }, { rootMargin: '300px' }) : null;

  function scan() {
    Array.prototype.forEach.call(document.querySelectorAll(SEL), function (u) {
      if (u.__bsw) return;
      var t = typeOf(u), anchor = u.querySelector(t.after);
      if (!anchor) return;
      var row = document.createElement(u.tagName === 'A' || anchor.tagName === 'SPAN' ? 'span' : 'div');
      row.className = 'bsw';
      row.setAttribute('aria-hidden', 'true');
      var ta = getComputedStyle(anchor).textAlign;
      if (ta === 'left' || ta === 'start') row.style.justifyContent = 'flex-start';
      anchor.parentNode.insertBefore(row, anchor.nextSibling);
      u.__bsw = row;
      if (io) io.observe(u); else fill(u, row);
    });
  }

  /* hover preview */
  document.addEventListener('pointerover', function (e) {
    var dot = e.target.closest && e.target.closest('.bsw-dot');
    if (!dot) return;
    var u = dot.closest(SEL);
    if (!u) return;
    var im = imgOf(u);
    if (im && !u.__base) u.__base = im.getAttribute('src');
    setImg(u, dot.getAttribute('data-p'));
  });
  document.addEventListener('pointerout', function (e) {
    var u = e.target.closest && e.target.closest(SEL);
    if (!u || u.contains(e.relatedTarget)) return;
    var back = u.__pick || u.__base;
    if (back) setImg(u, back);
  });

  /* click: commit the shade, never navigate */
  ['pointerdown', 'mousedown', 'touchstart'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      if (e.target.closest && e.target.closest('.bsw-dot')) e.stopPropagation();
    }, true);
  });
  document.addEventListener('click', function (e) {
    var dot = e.target.closest && e.target.closest('.bsw-dot');
    if (!dot) return;
    e.preventDefault();
    e.stopPropagation();
    var u = dot.closest(SEL);
    if (!u) return;
    Array.prototype.forEach.call(u.querySelectorAll('.bsw-dot'), function (d) { d.classList.toggle('is-on', d === dot); });
    var im = imgOf(u);
    if (im && !u.__base) u.__base = im.getAttribute('src');
    var p = dot.getAttribute('data-p'), url = dot.getAttribute('data-u');
    if (p) { u.__pick = p; setImg(u, p); }
    if (url) linksOf(u).forEach(function (a) { a.setAttribute('href', url); });
  }, true);

  /* backup for the observer: some browsers skip IntersectionObserver callbacks
     while a tab is in the background, so cards near the viewport are also
     filled on scroll and shortly after load */
  var pend = null;
  function sweep() {
    pend = null;
    var vh = window.innerHeight || 800;
    Array.prototype.forEach.call(document.querySelectorAll(SEL), function (u) {
      if (!u.__bsw || u.__bswDone) return;
      var r = u.getBoundingClientRect();
      if (r.bottom > -600 && r.top < vh + 600 && (r.width || r.height)) fill(u, u.__bsw);
    });
  }
  function queue() { if (!pend) pend = setTimeout(sweep, 250); }
  window.addEventListener('scroll', queue, { passive: true });

  function boot() {
    scan();
    setTimeout(sweep, 1200);
    if (window.MutationObserver) {
      var t = null;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(scan, 300);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
